// Provisional (Phase 1) inquiry paths. Forms are inactive previews: nothing is sent or stored.

const NAME = { id: "name", label: "Name", type: "text", placeholder: "Your name" };
const EMAIL = { id: "email", label: "Email", type: "email", placeholder: "you@organization" };

export const PATH_IDS = ["founding", "technical", "business", "research"];

export const ENGAGE_PATHS = {
  founding: {
    id: "founding", index: "01", title: "Founding & operating partnership", short: "Founding partnership",
    cta: "Discuss founding partnership",
    forWhom: "For people who may help form and operate the company.",
    description: "Ordo Intelligence is being formed around an already developed body of work. This path is for prospective founding and operating partners who want to understand that work and discuss a role in building the company.",
    covers: ["The developed body of work and its current state", "Founding and operating roles under consideration", "How the two operations are expected to grow"],
    fields: [
      NAME, EMAIL,
      { id: "background", label: "Current role or background", type: "text", wide: true, placeholder: "A line about where you come from" },
      { id: "role", label: "Where you would contribute", type: "choice", options: ["Operations", "Commercial", "Technical leadership", "Research", "Other"] },
      { id: "message", label: "What draws you to the work", type: "textarea", placeholder: "In your own words" },
    ],
  },
  technical: {
    id: "technical", index: "02", title: "Technical & infrastructure collaboration", short: "Technical collaboration",
    cta: "Discuss technical collaboration",
    forWhom: "For organizations and engineers building intelligent systems.",
    description: "For organizations interested in General Ordo Infrastructure, technical collaboration on the architecture, or an appropriately scoped deeper examination of the work.",
    covers: ["Incorporating General Ordo into an intelligent system", "Technical collaboration on the architecture", "Scoped examination beyond this public site"],
    fields: [
      NAME, EMAIL,
      { id: "organization", label: "Organization", type: "text", wide: true, placeholder: "Organization or team" },
      { id: "interest", label: "Interest", type: "multi", options: ["Infrastructure licensing", "Technical collaboration", "Scoped architectural examination"] },
      { id: "system", label: "The system or context you are working on", type: "textarea", placeholder: "What you are building, at whatever level of detail you are comfortable sharing" },
      { id: "scoped", label: "I understand that deeper examination may require an appropriate confidentiality arrangement.", type: "check" },
    ],
  },
  business: {
    id: "business", index: "03", title: "Business diagnostics & software", short: "Business inquiry",
    cta: "Start a business inquiry",
    forWhom: "For organizations with a problem they keep dealing with.",
    description: "For organizations considering Ordo Diagnostic, or interested in a specific applied software capability directly.",
    covers: ["Whether Ordo Diagnostic suits your situation", "A specific capability: Engine, Stewardship, Breakpoint, or Mesh", "What a first conversation would involve"],
    fields: [
      NAME, EMAIL,
      { id: "organization", label: "Organization", type: "text", wide: true, placeholder: "Organization" },
      { id: "problem", label: "Tell us one problem your business keeps dealing with", type: "textarea", placeholder: "Describe it in your own terms" },
      { id: "interest", label: "Starting point", type: "choice", options: ["Ordo Diagnostic", "Ordo Engine", "Ordo Stewardship", "Breakpoint", "Mesh", "Not sure yet"] },
    ],
  },
  research: {
    id: "research", index: "04", title: "Research, product & institutional collaboration", short: "Research & institutional",
    cta: "Discuss research collaboration",
    forWhom: "For researchers, product collaborators, institutions, and strategic supporters.",
    description: "For research partners, product-development collaborators, institutions, and strategic supporters interested in Human Structure and the products it originates.",
    covers: ["Research collaboration on Human Structure", "Product development: Briefcase, Forma, Lumen", "Institutional support and strategic relationships"],
    fields: [
      NAME, EMAIL,
      { id: "institution", label: "Institution or organization", type: "text", wide: true, placeholder: "Institution, lab, or organization" },
      { id: "kind", label: "Kind of collaboration", type: "choice", options: ["Research collaboration", "Product development", "Institutional support", "Strategic relationship"] },
      { id: "areas", label: "Areas of interest", type: "multi", options: ["Human Structure", "Briefcase", "Forma", "Lumen", "Physical Breakpoint"] },
      { id: "message", label: "What you have in mind", type: "textarea", placeholder: "In your own words" },
    ],
  },
};

export const engageHref = (path, from) =>
  `/engage?path=${path}${from ? `&from=${encodeURIComponent(from)}` : ""}`;

export const resolvePath = (path, from) => {
  if (ENGAGE_PATHS[path]) return path;
  if (!from) return "founding";
  if (from.startsWith("/ordo")) return "technical";
  if (from.startsWith("/enterprise")) return "business";
  if (from.startsWith("/research") || from.startsWith("/products")) return "research";
  return "founding";
};

const CAP_BY_PATH = {
  "/enterprise/diagnostic": "Ordo Diagnostic",
  "/ordo/engine": "Ordo Engine",
  "/ordo/stewardship": "Ordo Stewardship",
  "/enterprise/breakpoint": "Breakpoint",
  "/enterprise/mesh": "Mesh",
};
const AREA_BY_PATH = {
  "/research": "Human Structure",
  "/products/briefcase": "Briefcase",
  "/products/forma": "Forma",
  "/products/lumen": "Lumen",
};

export const initialValues = (pathId, from) => {
  if (pathId === "business" && CAP_BY_PATH[from]) return { interest: CAP_BY_PATH[from] };
  if (pathId === "research" && AREA_BY_PATH[from]) return { areas: [AREA_BY_PATH[from]] };
  if (pathId === "technical" && from === "/ordo/infrastructure") return { interest: ["Infrastructure licensing"] };
  return {};
};
